




























































import CommonBase from "../CommonBase";
import {Component, Inject, Watch} from "vue-property-decorator";
import Api from "./Api";
import {NotAuthenticated} from "../../modules/PlayServerClient";
import SigninIcon from "../SigninIcon.vue";
import {PhoneNumber} from "../../modules/models";
import {Vue} from "vue/types/vue";
import {firstOne, redirect} from "../../modules/utils";
import rd from "@/modules/vRoutedefs";
import TopHdr from "./TopHdr.vue";
import {NativeApi} from "@/modules/NativeBridge";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-signin-icon": SigninIcon,
        "at-top-hdr": TopHdr,
    }
})
export default class LoginForm extends CommonBase {
    @Inject()
    api!: Api;
    @Inject()
    nativeApi!: NativeApi;

    toggleShowPass() {
        this.showPass = !this.showPass;
    }
    showPass = false;
    pass: string = "";
    phonenum: string | null = null;
    working = false;
    errMsg: string = "";
    needNewPass = false;
    redir: string | null = null;

    checkPhone() {
        if(!this.phonenum || this.phonenum.length < 6) {
            return "Mobilnummer må fylles ut";
        }
        return true;
    }

    checkPass() {
        if(this.pass.length == 0) {
            return "Kode må fylles ut";
        }
        const passCode = Number(this.pass);
        if(passCode > 0) {
            return true;
        } else {
            return "Ugyldig innloggingskode. Koden skal bestå av tall."
        }
    }

    get autofocusChoice() {
        return this.phonenum && !this.pass ? 2 : 1;
    }

    get phone() {
        try {
            if(this.phonenum) return PhoneNumber.fromString(this.phonenum);
            return null;
        } catch (e) {
            return null;
        }
    }

    missingTo(signup: boolean) {
        return {name: rd.login.missing.name, query: rd.login.missing.q(this.phone, signup)};
    }

    async login() {
        if(this.phonenum != null) {
            this.working = true;
            try {
                const cp = this.checkPass();
                if(cp === true) {
                    await this.api.login(this.phonenum, this.pass, this.nativeApi);
                    const redirTo = this.redir || rd.start.path;
                    redirect(redirTo);
                } else {
                    this.errMsg = cp;
                }
            } catch (err) {
                if (err instanceof NotAuthenticated) {
                    if (err.num === 38 || err.num === 39) { // Wrong password, or no existing phone number found
                        const phone = PhoneNumber.fromString(this.phonenum);
                        const passCode = Number(this.pass);
                        // Check if there is pending ckey for the given credentials.
                        const ckeyCheck = await this.api.getLoginCkey(phone, passCode);
                        if (ckeyCheck.num == 60) {
                            const ckey = ckeyCheck.msg;
                            await ignoreRedundantNavErr(this.$router.push({name: "keylogin", query: {ckey: ckey}})); // Redirect to handle pending idcard phone confirm

                        } else if (err.num === 39) { // only check for pending person pass if login error was 39 (and not 38)
                            // Check if there is pending pkey for the given credentials.
                            const pkeyCheck = await this.api.getLoginPkey(phone, passCode); // See if there is pending phone login for the number/pass
                            if (pkeyCheck.num == 54) {
                                const pkey = pkeyCheck.msg;
                                await ignoreRedundantNavErr(this.$router.push({name: "keylogin", query: {pkey: pkey}})); // Redirect to handle pending phone confirm
                            } else if (pkeyCheck.num === 36) {
                                this.errMsg = "Mobilnummer ikke registrert, eller bekreftet for sent.";
                            } else {
                                this.errMsg = pkeyCheck.msg;
                            }
                        } else { // Other login error
                            this.errMsg = err.message;
                        }
                    } else {
                        this.emitError(err);
                    }
                } else {
                    this.emitError(err);
                }
            } finally {
                this.working = false;
            }
        } else {
            this.errMsg = "Mobilnummer ikke utfyllt";
        }
    }

    phoneFromQuery() {
        const phone =  firstOne(this.$route.query["phone"]);
        if(phone != null) {
            this.phonenum = phone;
        }
    }

    redirFromQuery() {
        const redir = firstOne(this.$route.query["redir"]);
        if(redir && redir.startsWith("/") && !redir.startsWith("//")) {
            this.redir = redir;
            this.$emit("at-snack", "Logg inn for å fortsette til ønsket side");
        } else {
            this.redir = null;
        }
    }

    focus() {
        const refToFocus = this.phonenum && this.pass == "" ? "pass" : "phone";
        const comp = this.$refs[refToFocus] as Vue;
        if(comp) {
            const inp = comp.$el.querySelector("input") as HTMLInputElement;
            if (inp) {
                inp.focus();
            }
        }
    }

    @Watch("pass")
    onPassChanged() {
        this.errMsg = "";
    }

    @Watch("$route")
    onRouteChanged(to, from) {
        if(to.name == "login") {
            let needNewPass = false;
            if (to.query.phone) {
                this.phoneFromQuery();
                if (from.name == "pending") {
                    needNewPass = true;
                    this.pass = "";
                }
            }
            this.needNewPass = needNewPass;
            if(to.query.redir) {
                this.redirFromQuery();
            }
        }
    }

    created() {
        this.phoneFromQuery();
        this.redirFromQuery();
    }
    // Component has been activated after load or by navigating to it (after it has been loaded)
    // Set focus on correct input based on current state.
    activated() {
        this.focus();
    }
}
